export default "__VITE_ASSET__BlMXn8CN__"